/* tslint:disable */
import { User } from './user';
import { ConnectionUser } from './connection-user';

/**
 */
export class ViewUsers {
    online?: User[];
    offline?: ConnectionUser[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-users.ts